function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function e(_ref) {
  var e = _ref.node,
      _ref$child = _ref.child,
      t = _ref$child === void 0 ? [] : _ref$child,
      _ref$from = _ref.from,
      n = _ref$from === void 0 ? [] : _ref$from,
      _ref$scope = _ref.scope,
      r = _ref$scope === void 0 ? {} : _ref$scope,
      _ref$meta = _ref.meta,
      o = _ref$meta === void 0 ? {} : _ref$meta;
  return {
    from: n.map(_get__("X")),
    seq: e,
    next: t.map(_get__("X")),
    meta: o,
    scope: r
  };
}

function t(e) {
  return e.compositeName ? e.compositeName.fullName : e.domainName ? e.domainName.fullName : e.id;
}

function n(e) {
  var n = 0;
  var r = Object.values(e),
      o = _get__("Fe") - 1,
      a = r.length - 1;
  var i = 'combine(';

  for (var _i = 0, _r = r; _i < _r.length; _i++) {
    var _e2 = _r[_i];

    var _r2 = n === o || a === n ? '' : ', ';

    if (_get__("Ie")(_e2) || _get__("qe")(_e2) || _get__("Ce")(_e2) ? i += _get__("t")(_e2) + _r2 : i += _e2.toString() + _r2, n += 1, '' === _r2) break;
  }

  return i + ')';
}

function r(e, t, n) {
  this.shortName = e, this.fullName = t, this.path = n;
}

function o(e, t) {
  var n, o;
  var a = e;
  return void 0 === t ? (n = 0 === e.length ? [] : [e], o = e) : 0 === e.length ? (n = t.path, o = t.fullName) : (n = t.path.concat([e]), o = 0 === t.fullName.length ? e : t.fullName + '/' + e), new (_get__("r"))(a, o, n);
}

function a(e) {
  return e(this);
}

function i() {
  var e = this.indexOf();
  -1 !== e && (this.splice(e, 1), this.indexOf = _get__("He"), this.splice = _get__("Me"));
}

function s(_ref2) {
  var n = _ref2.name,
      r = _ref2.parent,
      _ref2$config = _ref2.config,
      i = _ref2$config === void 0 ? {} : _ref2$config;

  var c = _get__("Be")(),
      u = n || c,
      l = _get__("o")(u, r),
      f = l.fullName,
      d = _get__("e")({
    node: [_get__("L").emit({
      fullName: f
    })]
  }),
      p = function p(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    return p.create(e, f, t);
  };

  return p.getType = function () {
    return f;
  }, p.create = function (e) {
    return _get__("ge")(p, e), e;
  }, p.kind = _get__("P"), p[T] = function () {
    return p;
  }, p.id = c, p.watch = function (e, n) {
    return _get__("Re")(e, {
      scope: {
        trigger: e,
        handler: n
      },
      node: [_get__("we"), _get__("L").run({
        fn: function fn(e, _ref3) {
          var n = _ref3.trigger,
              r = _ref3.handler;
          return r(e, _get__("t")(n));
        }
      })]
    });
  }.bind(null, p), p.map = function (e, t) {
    var n = _get__("s")({
      name: e.shortName + ' → *',
      parent: e.domainName
    });

    return _get__("Re")(e, {
      child: [n],
      scope: {
        handler: t
      },
      node: [_get__("L").compute({
        fn: function fn(e, _ref4) {
          var t = _ref4.handler;
          return t(e);
        }
      })]
    }), n;
  }.bind(null, p), p.filter = function (e, t) {
    var n = _get__("s")({
      name: e.shortName + ' →? *',
      parent: e.domainName
    });

    var r, o;
    return 'object' == _typeof(t) ? (o = {
      fn: t.fn
    }, r = [_get__("L").filter({
      fn: function (e) {
        function t(t, n) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e, _ref5) {
        var t = _ref5.fn;
        return t(e);
      })
    })]) : (o = {
      fn: t
    }, r = [_get__("L").compute({
      fn: function (e) {
        function t(t, n) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e, _ref6) {
        var t = _ref6.fn;
        return t(e);
      })
    }), _get__("L").filter({
      fn: function fn(e) {
        return void 0 !== e;
      }
    })]), _get__("Re")(e, {
      scope: o,
      child: [n],
      node: r
    }), n;
  }.bind(null, p), p.prepend = function (e, t) {
    var n = _get__("s")({
      name: '* → ' + e.shortName,
      parent: e.domainName
    });

    return _get__("Re")(n, {
      child: [e],
      scope: {
        handler: t
      },
      node: [_get__("L").compute({
        fn: function fn(e, _ref7) {
          var t = _ref7.handler;
          return t(e);
        }
      })]
    }), n;
  }.bind(null, p), p.subscribe = function (e, t) {
    return e.watch(function (e) {
      return t.next(e);
    });
  }.bind(null, p), p.thru = _get__("a").bind(p), p.graphite = d, p.shortName = u, p.domainName = r, p.compositeName = l, p.defaultConfig = i, p;
}

function c() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = 'createStore: Second argument should be plain object, but you passed %s.';
  _get__("xe")('object' == _typeof(e) && null !== e, t, e), void 0 !== (null == e ? void 0 : e.ɔ) && _get__("xe")('object' == _typeof(e.ɔ) && null !== e.ɔ, t, e.ɔ);
  var n = Object.assign({}, e, 'object' == _typeof(e.ɔ) ? e.ɔ : {});
  return delete n.ɔ, n;
}

function u(e, t) {
  var n = 'object' == _typeof(e) ? Object.assign({}, _get__("c")(t), e) : _get__("c")(t);
  return {
    config: n,
    name: 'object' == _typeof(e) || void 0 === e ? n.name : e
  };
}

function l(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _get__2 = _get__("u")(e, t),
      n = _get__2.config,
      r = _get__2.name;

  return _get__("s")({
    name: r,
    config: n
  });
}

function f(e) {
  _get__("z")('function' == typeof e || 'object' == _typeof(e) && null !== e, 'expect observable to be object or function');

  var t = _get__("T") in e ? e[T]() : e;

  _get__("z")('subscribe' in t, 'expect observable to have .subscribe');

  var n = _get__("l")(),
      r = _get__("Q").bind(null, n, {});

  return t.subscribe({
    next: n,
    error: r,
    complete: r
  }), n;
}

function d() {}

function p() {}

function m(e) {
  return _get__("$")(e.plainState);
}

function h(e, t) {
  var n = e.subscribers.get(t);
  void 0 !== n && (n(), e.subscribers["delete"](t));
}

function b(e, n, r) {
  var o = n,
      a = e.subscribers.get(o);
  return a && a(), e.subscribers.set(o, _get__("Re")(o, {
    scope: {
      handler: r,
      state: e.plainState,
      trigger: o
    },
    child: [e],
    node: [_get__("L").compute({
      fn: function fn(e, _ref8) {
        var n = _ref8.handler,
            r = _ref8.state,
            o = _ref8.trigger;
        var a = n(_get__("$")(r), e, _get__("t")(o));
        if (void 0 !== a) return _get__("ee")(r, a);
      }
    })]
  })), this;
}

function g(e, n, r) {
  var o = 'watch requires function handler';

  switch (r && (null == n ? void 0 : n.kind)) {
    case 'store':
    case 'event':
    case 'effect':
      return _get__("z")('function' == typeof r, o), n.watch(function (o) {
        return r(_get__("m")(e), o, _get__("t")(n));
      });

    default:
      return _get__("z")('function' == typeof n, o), _get__("v")(e, n);
  }
}

function v(e, t) {
  _get__("z")('function' == typeof t, 'Expected the listener to be a function');

  var n = 'Got initial error',
      r = _get__("m")(e);

  _get__("d")(e, 'subscribe');

  try {
    t(r), n = 'Initial';
  } catch (e) {
    console.error(e);
  }

  return _get__("p")(n), _get__("Re")(e, {
    node: [_get__("we"), _get__("L").run({
      fn: function fn(n) {
        var o = null;

        if (_get__("d")(e, 'subscribe'), n !== r) {
          r = n;

          try {
            t(n);
          } catch (e) {
            console.error(e), o = 'Got error';
          }

          _get__("p")(o);
        } else _get__("p")(o);
      }
    })]
  });
}

function y(t) {
  var n = t.currentState,
      r = t.config,
      i = t.parent,
      s = r.name,
      c = _get__("Z")(n),
      u = s || c.id,
      f = n,
      N = _get__("o")(u, i),
      S = _get__("l")('update ' + u),
      w = {
    graphite: _get__("e")({
      scope: {
        state: c,
        oldState: n
      },
      node: [_get__("L").filter({
        fn: function fn(e) {
          return void 0 !== e;
        }
      }), _get__("L").update({
        store: c
      }), _get__("L").filter({
        fn: function fn(e, t) {
          return e === t.oldState ? 0 : (t.oldState = e, 1);
        }
      })]
    }),
    kind: _get__("A"),
    id: c.id,
    shortName: u,
    domainName: i,
    defaultConfig: r,
    defaultState: f,
    plainState: c,
    subscribers: new Map(),
    compositeName: N
  },
      k = {
    compositeName: w.compositeName,
    graphite: w.graphite,
    kind: _get__("A"),
    id: c.id,
    shortName: u,
    domainName: i,
    setState: function setState(e, t) {
      var n = _get__("m")(w),
          r = 'function' == typeof t ? t(n, e) : e;

      _get__("ge")(k, r);
    },
    off: _get__("h").bind(null, w),
    watch: _get__("g").bind(null, w),
    updates: S,
    subscribe: _get__("v").bind(null, w),
    getState: _get__("m").bind(null, w),
    stateRef: c
  };

  return k.defaultConfig = r, k.reset = function (e) {
    for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      t[_key2 - 1] = arguments[_key2];
    }

    for (var _i2 = 0, _t = t; _i2 < _t.length; _i2++) {
      var _n = _t[_i2];

      _get__("b").call(this, e, _n, function () {
        return e.defaultState;
      });
    }

    return this;
  }.bind(k, w), k.on = _get__("b").bind(k, w), k.defaultState = f, k.map = function (e, t, n) {
    var r;

    _get__("d")(e, 'map');

    var o = 'Got initial error';

    try {
      var _a = e.getState();

      void 0 !== _a && (r = t(_a, n)), o = 'Initial';
    } catch (e) {
      console.error(e);
    }

    _get__("p")(o);

    var a = this({
      config: {
        name: e.shortName + ' → *'
      },
      currentState: r,
      parent: e.domainName
    });
    return _get__("Re")(e, {
      child: [a],
      scope: {
        store: e,
        handler: t,
        state: a.stateRef
      },
      node: [_get__("L").compute({
        fn: function fn(e, _ref9) {
          var t = _ref9.state,
              n = _ref9.store,
              r = _ref9.handler;

          _get__("d")(n, 'map');

          var o,
              a = 'Got error';

          try {
            o = r(e, _get__("$")(t)), a = null;
          } catch (e) {
            console.error(e);
          }

          return _get__("p")(a), o;
        }
      }), _get__("Se")]
    }), a;
  }.bind(_get__("y"), k), k.thru = _get__("a").bind(k), k.dispatch = function (e) {
    return e;
  }.bind(null), k[T] = function (e) {
    var t = {
      subscribe: function subscribe(t) {
        return _get__("z")('object' == _typeof(t) && null !== t, 'Expected the observer to be an object.'), _get__("v")(e, function (e) {
          t.next && t.next(e);
        });
      }
    };
    return t[T] = function () {
      return this;
    }, t;
  }.bind(null, w), _get__("Te")({
    from: k,
    to: S
  }), k;
}

function N(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _get__("z")(void 0 !== e, "createStore: First argument can't be undefined, use null instead."), _get__("y")({
    currentState: e,
    config: _get__("c")(t)
  });
}

function S(e, t) {
  var n = _get__("o")(t, e.domainName);

  e.shortName = t, e.compositeName ? (e.compositeName.path = n.path, e.compositeName.shortName = n.shortName, e.compositeName.fullName = n.fullName) : e.compositeName = n;
}

function w(e, t) {
  var n = Array.isArray(e) ? _get__("We")(e, function (e) {
    return e.slice();
  }, []) : _get__("We")(e, function (e) {
    return Object.assign({}, e);
  }, {});
  return t ? n.map(t) : n;
}

function k(e, t) {
  var n;
  return _get__("w")(n = t('defaultShape' in e ? e.defaultShape : e.defaultState));
}

function x(e, t) {
  var n = {};

  for (var _r3 in t) {
    var _o = t[_r3],
        _a2 = n[_r3] = _get__("l")(_r3);

    e.on(_a2, _o);
  }

  return n;
}

function j(e) {
  var t = {};

  for (var _n2 in e) {
    var _r4 = e[_n2];
    t[_n2] = _get__("Ie")(_r4) ? _r4 : _get__("y")({
      currentState: _r4,
      config: {
        name: _n2
      }
    });
  }

  return t;
}

function E(e, t) {
  var n = _get__("y")({
    currentState: t,
    parent: e.domainName,
    config: {
      name: e.shortName
    }
  });

  return n.on(e.done, function (e, _ref10) {
    var t = _ref10.result;
    return t;
  }), n;
}

function I(e, t) {
  var n = _get__("y")({
    currentState: t,
    parent: e.domainName,
    config: {
      name: e.shortName
    }
  });

  return n.on(e, function (e, t) {
    return t;
  }), n;
}

function q(e, t) {
  return _get__("Ie")(e) ? e : _get__("qe")(e) ? _get__("I")(e, t) : _get__("Ce")(e) ? _get__("E")(e, t) : _get__("j")(e);
}

function C(e, t) {
  return function (n) {
    return t(e.getState(), n);
  };
}

function O() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  var t, n, r;

  _get__("z")(e.length > 0, 'at least one argument required');

  {
    var _r5 = e[e.length - 1];
    'function' == typeof _r5 ? (n = e.slice(0, -1), t = _r5) : n = e;
  }

  e: {
    if (1 === n.length) {
      var _e3 = n[0];

      if (!_get__("Ie")(_e3)) {
        r = _e3;
        break e;
      }
    }

    r = n, t && (t = _get__("Ke")(t));
  }

  return _get__("w")(r, t);
}

function D(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var o;
  void 0 === t && 'source' in e && (t = e.clock || e.sampler, n = e.fn, r = e.greedy, o = e.target, e = e.source), void 0 === t && (t = e);

  var a = _get__("Qe")(e),
      i = _get__("Qe")(t);

  return 'boolean' == typeof n && (r = n, n = void 0), (_get__("Ie")(a) ? _get__("Ie")(i) ? _get__("Je") : _get__("_e") : _get__("Le"))(a, i, n, r, o);
}

function F() {
  var _this = this;

  var e = new Promise(function (e, t) {
    _this.rs = e, _this.rj = t;
  });
  e.anyway = function () {
    return _get__("xe")(0, '.anyway is deprecated, use .finally'), e.then(function () {}, function () {});
  }, this.req = e;
}

function H(_ref11) {
  var e = _ref11.name,
      t = _ref11.parent,
      n = _ref11.config;

  var r = n.handler,
      o = _get__("s")({
    name: e,
    parent: t,
    config: n
  }),
      a = o.create,
      i = _get__("s")({
    name: o.shortName + ' done',
    parent: t,
    config: n
  }),
      c = _get__("s")({
    name: o.shortName + ' fail',
    parent: t,
    config: n
  });

  i.graphite.seq.push(_get__("Xe")), c.graphite.seq.push(_get__("Xe"));

  var u = r || function () {
    return _get__("xe")(0, 'no thunk used in %s', this.getType()), Promise.resolve();
  }.bind(o);

  o.done = i, o.fail = c, o.use = function (e) {
    return u = e, o;
  };

  var l = function l() {
    return u;
  };

  return o.use.getCurrent = l, o.kind = _get__("V"), o.graphite.scope = {
    done: i,
    fail: c,
    getHandler: l
  }, o.graphite.seq.push(_get__("L").compute({
    fn: function fn(e) {
      return 'object' == _typeof(e) && null !== e && 'ɔ' in e ? e.ɔ : {
        params: e,
        req: {
          rs: function rs(e) {},
          rj: function rj(e) {}
        }
      };
    }
  }), _get__("L").run({
    fn: function fn(_ref12, _ref13) {
      var e = _ref12.params,
          t = _ref12.req;
      var n = _ref13.getHandler,
          r = _ref13.done,
          o = _ref13.fail;
      return function (e, t, n, r) {
        var o,
            a,
            i = 0;

        try {
          a = e(t);
        } catch (e) {
          i = 1, o = e;
        }

        i ? r(o) : 'object' != _typeof(a) || null === a || 'function' != typeof a.then ? n(a) : a.then(n, r);
      }(n(), e, function (e) {
        var t = this.event,
            n = this.params,
            r = this.handler;

        _get__("ve")(t, {
          handler: r,
          toHandler: e,
          result: {
            params: n,
            result: e
          }
        });
      }.bind({
        event: r,
        params: e,
        handler: t.rs
      }), function (e) {
        var t = this.event,
            n = this.params,
            r = this.handler;

        _get__("ve")(t, {
          handler: r,
          toHandler: e,
          result: {
            params: n,
            error: e
          }
        });
      }.bind({
        event: o,
        params: e,
        handler: t.rj
      })), e;
    }
  })), o.create = function (e, t, n) {
    var r = new (_get__("F"))();
    return a({
      "ɔ": {
        params: e,
        req: r
      }
    }, o.getType(), n), r.req;
  }, o.pending = _get__("N")(Boolean(0)).on(o, function () {
    return Boolean(1);
  }).reset(i).reset(c), o;
}

function M(e, t) {
  var _get__3 = _get__("u")(e, t),
      n = _get__3.config,
      r = _get__3.name;

  return _get__("H")({
    name: r,
    domainName: '',
    config: n
  });
}

function R(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _get__4 = _get__("u")(e, t),
      n = _get__4.config,
      r = _get__4.name;

  return function e(_ref14) {
    var t = _ref14.name,
        _ref14$config = _ref14.config,
        n = _ref14$config === void 0 ? {} : _ref14$config,
        r = _ref14.parent,
        a = _ref14.parentHooks;

    var i = _get__("et")(),
        u = _get__("o")(t || '', r),
        l = new (_get__("Ye"))(),
        f = function (e, t, n) {
      var r;
      return (r = n ? _get__("$e")(n) : _get__("Ze")(t)).domain.watch(function (t) {
        e.domains.add(t);
      }), r.event.watch(function (t) {
        e.events.add(t);
      }), r.store.watch(function (t) {
        e.storages.add(t);
      }), r.effect.watch(function (t) {
        e.effects.add(t);
      }), r;
    }(l, u, a);

    return {
      compositeName: u,
      id: i,
      defaultConfig: n,
      getType: function getType() {
        return u.fullName;
      },
      onCreateEvent: function onCreateEvent(e) {
        return l.events.forEach(e), f.event.watch(e);
      },
      onCreateEffect: function onCreateEffect(e) {
        return l.effects.forEach(e), f.effect.watch(e);
      },
      onCreateStore: function onCreateStore(e) {
        return l.storages.forEach(e), f.store.watch(e);
      },
      onCreateDomain: function onCreateDomain(e) {
        return l.domains.forEach(e), f.domain.watch(e);
      },
      event: function event(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var n = _get__("c")(t),
            r = _get__("s")({
          name: e,
          parent: u,
          config: n
        });

        return f.event(r), r;
      },
      effect: function effect(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var n = _get__("c")(t),
            r = _get__("H")({
          name: e,
          domainName: u.fullName,
          parent: u,
          config: n
        });

        return f.effect(r), r;
      },
      domain: function domain(t) {
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var r = _get__("c")(n),
            o = e({
          name: t,
          parent: u,
          parentHooks: f,
          config: r
        });

        return f.domain(o), o;
      },
      store: function store(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var n = _get__("c")(t),
            r = _get__("y")({
          currentState: e,
          parent: u,
          config: n
        });

        return f.store(r), r;
      },
      kind: _get__("W")
    };
  }({
    name: void 0 === r ? '' : r,
    config: n
  });
}

import T from 'symbol-observable';
var B = "19.1.0",
    G = 'production' !== process.env.NODE_ENV;
var z = _get__("G") ? function e(t, n) {
  for (var _len4 = arguments.length, r = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    r[_key4 - 2] = arguments[_key4];
  }

  if (!t) {
    var _t2 = Error();

    Error.captureStackTrace && Error.captureStackTrace(_t2, e), _t2.name = 'Invariant Violation';
    var _o2 = 0;
    throw _t2.message = n.replace(/%s/g, function () {
      return r[_o2++];
    }), _t2;
  }
} : function (e) {
  if (!e) throw Error('Minified exception occurred');
};
var A = 'store',
    P = 'event',
    V = 'effect',
    W = 'domain';
var K = Object.freeze({
  store: _get__("A"),
  event: _get__("P"),
  effect: _get__("V"),
  domain: _get__("W")
});

var U = function U() {
  var e = 0;
  return function () {
    return (++e).toString(36);
  };
},
    _ = _get__("U")(),
    J = function J(e, t) {
  return {
    id: _get__("_")(),
    type: e,
    group: 'cmd',
    data: t
  };
},
    L = {
  barrier: function barrier(_ref15) {
    var e = _ref15.barrierID,
        _ref15$priority = _ref15.priority,
        t = _ref15$priority === void 0 ? "barrier" : _ref15$priority;
    return _get__("J")('barrier', {
      barrierID: e,
      priority: t
    });
  },
  compute: _get__("J").bind(null, 'compute'),
  emit: _get__("J").bind(null, 'emit'),
  filter: _get__("J").bind(null, 'filter'),
  run: _get__("J").bind(null, 'run'),
  tap: _get__("J").bind(null, 'tap'),
  update: _get__("J").bind(null, 'update')
},
    Q = function Q(e) {
  var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref16.deep;

  var n = _get__("X")(e);

  t && n.next.forEach(function (e) {
    return _get__("Q")(e, {
      deep: t
    });
  }), n.from.forEach(function (e) {
    var t = e.next.indexOf(n);
    -1 !== t && e.next.splice(t, 1);
  }), n.from.length = 0, n.next.length = 0, n.seq.length = 0, n.scope = null;
},
    X = function X(e) {
  return e.graphite || e;
},
    Y = _get__("U")(),
    Z = function Z(e) {
  return {
    id: _get__("Y")(),
    current: e
  };
},
    $ = function $(_ref17) {
  var e = _ref17.current;
  return e;
},
    ee = function ee(e, t) {
  return e.current = t;
},
    te = _get__("U")(),
    ne = function ne(e) {
  switch (e) {
    case 'child':
      return 0;

    case 'pure':
      return 1;

    case 'barrier':
      return 2;

    case 'sampler':
      return 3;

    case 'effect':
      return 4;

    default:
      return -1;
  }
};

var re = function re(e, t) {
  _classCallCheck(this, re);

  this.value = {
    current: e
  }, this.parent = t;
};

var oe = function oe(e, t, n, r) {
  _classCallCheck(this, oe);

  this.value = e, this.rank = t, this.left = n, this.right = r;
};

var ae = function ae(e) {
  return e ? _get__("ie")(e.left, e.right) : null;
},
    ie = function ie(e, t) {
  var n, r, o, a, i, s, c;

  for (;;) {
    var u, l;
    if (n = t, !(r = e)) return n;
    if (!n) return r;
    if (a = r.left, !_get__("ce")(o = r.value, n.value)) return i = _get__("ie")(r.right, n), (s = (null === (u = a) || void 0 === u ? void 0 : u.rank) || 0) >= (c = (null === (l = i) || void 0 === l ? void 0 : l.rank) || 0) ? new (_get__("oe"))(o, c + 1, a, i) : new (_get__("oe"))(o, s + 1, i, a);
    t = r, e = n;
  }
};

var se = function se(e) {
  _classCallCheck(this, se);

  this.isChanged = 1, this.isFailed = 0, this.scope = e;
};

var ce = function ce(e, t) {
  return e.type === t.type ? e.id > t.id : _get__("ne")(e.type) > _get__("ne")(t.type);
};

var ue = 0,
    le = null;

var fe = new Set(),
    de = function de(e) {
  _assign__("le", function (e, t) {
    return _get__("ie")(new (_get__("oe"))(e, 1, null, null), t);
  }(e, _get__("le")));
},
    pe = function pe(_ref18, o) {
  var e = _ref18.step,
      t = _ref18.firstIndex,
      n = _ref18.scope,
      r = _ref18.resetStop;
  var a = new (_get__("se"))(e.scope);

  for (var _r6 = t; _r6 < e.seq.length && !o.stop; _r6++) {
    var _i3 = e.seq[_r6];
    if (_r6 === t) 'barrier' === _i3.type && _get__("fe")["delete"](_i3.data.barrierID);else switch (_i3.type) {
      case 'run':
        return void _get__("de")({
          step: e,
          firstIndex: _r6,
          scope: n,
          resetStop: 0,
          type: 'effect',
          id: _update_operation__("++", "ue", true)
        });

      case 'barrier':
        {
          var _t3 = _i3.data.barrierID;
          return void (_get__("fe").has(_t3) || (_get__("fe").add(_t3), _get__("de")({
            step: e,
            firstIndex: _r6,
            scope: n,
            resetStop: 0,
            type: _i3.data.priority,
            id: _update_operation__("++", "ue", true)
          })));
        }
    }
    (0, _get__("ye")[_i3.type])(a, _i3.data, n.value), o.stop = a.isFailed || !a.isChanged;
  }

  if (!o.stop) for (var _t4 = 0; _t4 < e.next.length; _t4++) {
    var _r7 = new (_get__("re"))(_get__("$")(n.value), n);

    _get__("de")({
      step: e.next[_t4],
      firstIndex: 0,
      scope: _r7,
      resetStop: 1,
      type: 'child',
      id: _update_operation__("++", "ue", true)
    });
  }
  r && (o.stop = 0);
};

var me = 0;

var he = function he(e, t) {
  _get__("de")({
    step: _get__("X")(e),
    firstIndex: 0,
    scope: new (_get__("re"))(t, null),
    resetStop: 0,
    type: 'pure',
    id: _update_operation__("++", "ue", true)
  });
},
    be = function be() {
  var e = _get__("me");

  _assign__("me", 1);

  var t = {
    stop: 0
  };
  var n;

  for (; _get__("le");) {
    n = _get__("le").value, _assign__("le", _get__("ae")(_get__("le"))), _get__("pe")(n, t);
  }

  _assign__("me", e);
},
    ge = function ge(e, t) {
  _get__("he")(e, t), _get__("be")();
},
    ve = function ve(e, t) {
  _get__("he")(e, t), _get__("me") || _get__("be")();
},
    ye = {
  barrier: function barrier(e, t, n) {
    e.isFailed = 0, e.isChanged = 1;
  },
  emit: function emit(e, t, n) {},
  filter: function filter(e, t, n) {
    var r = _get__("Ne")({
      arg: _get__("$")(n),
      val: e.scope,
      fn: t.fn
    });

    e.isChanged = !!r.result;
  },
  run: function run(e, t, n) {
    var r = _get__("Ne")({
      arg: _get__("$")(n),
      val: e.scope,
      fn: t.fn
    });

    e.isFailed = r.err, _get__("ee")(n, r.result);
  },
  update: function update(e, t, n) {
    _get__("ee")(t.store, _get__("$")(n));
  },
  compute: function compute(e, t, n) {
    var r = _get__("Ne")({
      arg: _get__("$")(n),
      val: e.scope,
      fn: t.fn
    });

    e.isFailed = r.err, _get__("ee")(n, r.result);
  },
  tap: function tap(e, t, n) {
    var r = _get__("Ne")({
      arg: _get__("$")(n),
      val: e.scope,
      fn: t.fn
    });

    e.isFailed = r.err;
  }
},
    Ne = function Ne(_ref19) {
  var e = _ref19.fn,
      t = _ref19.arg,
      n = _ref19.val;
  var r = {
    err: 0,
    result: null
  };

  try {
    r.result = e(t, n);
  } catch (e) {
    console.error(e), r.err = 1;
  }

  return r;
},
    Se = _get__("L").filter({
  fn: function fn(e, _ref20) {
    var t = _ref20.state;
    return e !== _get__("$")(t) && void 0 !== e;
  }
}),
    we = _get__("L").compute({
  fn: function fn(e) {
    return e;
  }
});

var ke = Object.freeze({
  filterChanged: _get__("Se"),
  noop: _get__("we")
}),
    xe = _get__("G") ? function (e, t) {
  var _console;

  for (var _len5 = arguments.length, n = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    n[_key5 - 2] = arguments[_key5];
  }

  e || (_console = console).error.apply(_console, ['Warning: ' + t].concat(n));
} : function () {};

var je = function je(e) {
  return ('function' == typeof e || 'object' == _typeof(e) && null !== e) && 'kind' in e;
},
    Ee = function Ee(e) {
  return function (t) {
    return _get__("je")(t) && t.kind === e;
  };
},
    Ie = _get__("Ee")(_get__("A")),
    qe = _get__("Ee")(_get__("P")),
    Ce = _get__("Ee")(_get__("V")),
    Oe = _get__("Ee")(_get__("W"));

var De = Object.freeze({
  unit: _get__("je"),
  store: _get__("Ie"),
  event: _get__("qe"),
  effect: _get__("Ce"),
  domain: _get__("Oe")
});

var Fe = 25,
    He = function He() {
  return -1;
},
    Me = function Me() {
  return [];
},
    Re = function Re(t, n) {
  return _get__("Te")({
    from: t,
    to: _get__("e")(n)
  });
},
    Te = function Te(e) {
  var t = _get__("X")(e.from),
      n = _get__("X")(e.to);

  return t.next.push(n), function (e) {
    var t = e.parent.next,
        n = {
      indexOf: t.indexOf.bind(t, e.child),
      splice: t.splice.bind(t)
    },
        r = _get__("i").bind(n);

    return r.unsubscribe = _get__("i").bind(n), r;
  }({
    child: n,
    parent: t
  });
},
    Be = _get__("U")();

var Ge = null,
    ze = null;

if (_get__("G")) {
  var Ae = function Ae(t) {
    return _e4 + " " + t;
  };

  var Pe = function Pe(e, t) {
    return e + "." + t;
  };

  var Ve = function Ve(e, t) {
    return e + " (#" + t + ")";
  };

  var _e4 = '☄',
      _n3 = 'undefined' != typeof performance && 'function' == typeof performance.mark && 'function' == typeof performance.clearMarks && 'function' == typeof performance.measure && 'function' == typeof performance.clearMeasures;

  var _r8 = function _r8(t, n) {
    return _e4 + " " + t + (n ? " Warning: " + n : '');
  };

  var _o3 = function _o3() {
    null !== _get__("Ge") && null !== _get__("ze") && function (e, n) {
      var r = _get__("t")(e),
          o = e.id;

      var a;
      a = Ve(Pe(r, n), o), performance.clearMarks(Ae(a));
    }(_get__("ze"), _get__("Ge")), _assign__("ze", null), _assign__("Ge", null);
  };

  _assign__("d", function (e, r) {
    _n3 && (_o3(), function (e, n) {
      var r = _get__("t")(e),
          o = e.id;

      return a = Ve(Pe(r, n), o), performance.mark(Ae(a)), 1;
      var a;
    }(e, r) && (_assign__("ze", e), _assign__("Ge", r)));
  }), _assign__("p", function (e) {
    _n3 && (null !== _get__("Ge") && null !== _get__("ze") && function (e, n, o) {
      var a = _get__("t")(e),
          i = e.id,
          s = Pe(a, n);

      (function (e, t, n) {
        var o = Ae(t),
            a = _r8(e, n);

        try {
          performance.measure(a, o);
        } catch (e) {}

        performance.clearMarks(o), performance.clearMeasures(a);
      })(s, Ve(s, i), o);
    }(_get__("ze"), _get__("Ge"), e), _assign__("Ge", null), _assign__("ze", null));
  });
}

var We = function We(e, t, r) {
  var o = [_get__("L").filter({
    fn: function fn(e, _ref21) {
      var t = _ref21.target,
          n = _ref21.key;
      return e !== _get__("$")(t)[n] && void 0 !== e;
    }
  }), _get__("L").tap({
    fn: function fn(e, _ref22) {
      var t = _ref22.isFresh,
          n = _ref22.target,
          r = _ref22.clone;
      _get__("$")(t) || (_get__("ee")(n, r(_get__("$")(n))), _get__("ee")(t, 1));
    }
  }), _get__("L").tap({
    fn: function fn(e, _ref23) {
      var t = _ref23.target,
          n = _ref23.key;
      _get__("$")(t)[n] = e;
    }
  }), _get__("L").barrier({
    barrierID: _get__("te")()
  }), _get__("L").compute({
    fn: function fn(e, _ref24) {
      var t = _ref24.isFresh,
          n = _ref24.target;
      return _get__("ee")(t, 0), _get__("$")(n);
    }
  })],
      a = t(r),
      i = _get__("y")({
    currentState: a,
    config: {
      name: _get__("n")(e)
    }
  }),
      s = _get__("Z")(0);

  for (var _n4 in e) {
    var _c = e[_n4];
    _get__("Ie")(_c) ? (r[_n4] = _c.defaultState, a[_n4] = _c.getState(), _get__("Re")(_c, {
      scope: {
        key: _n4,
        clone: t,
        target: i.stateRef,
        isFresh: s
      },
      node: o,
      child: [i]
    })) : a[_n4] = r[_n4] = _c;
  }

  return i.defaultShape = e, i.defaultState = r, i;
},
    Ke = function Ke(e) {
  return function (t) {
    return e.apply(void 0, _toConsumableArray(t));
  };
},
    Ue = function Ue(e, t, n, r, o) {
  return _get__("Re")(t, {
    scope: {
      state: e.stateRef,
      fn: n
    },
    child: [o],
    node: [!r && _get__("we"), !r && _get__("L").barrier({
      barrierID: _get__("te")(),
      priority: 'sampler'
    }), _get__("L").compute({
      fn: n ? function (e, _ref25) {
        var t = _ref25.state,
            n = _ref25.fn;
        return n(_get__("$")(t), e);
      } : function (e, _ref26) {
        var t = _ref26.state;
        return _get__("$")(t);
      }
    })].filter(Boolean)
  }), o;
},
    _e = function _e(e, t, n, r, o) {
  return _get__("Ue")(e, t, n, r, o || _get__("s")({
    name: e.shortName,
    parent: e.domainName
  }));
},
    Je = function Je(e, t, n, r, o) {
  var a = _get__("$")(e.stateRef);

  return _get__("Ue")(e, t, n, r, o || _get__("y")({
    currentState: n ? n(a, _get__("$")(t.stateRef)) : a,
    config: {
      name: e.shortName
    },
    parent: e.domainName
  }));
},
    Le = function Le(e, t, n, r, o) {
  o = o || _get__("s")({
    name: e.shortName,
    parent: e.domainName
  });

  var a = _get__("Z")(0),
      i = _get__("Z")(),
      c = _get__("Z")();

  return _get__("Re")(e, {
    scope: {
      hasSource: a
    },
    node: [_get__("L").update({
      store: i
    }), _get__("L").tap({
      fn: function fn(e, _ref27) {
        var t = _ref27.hasSource;

        _get__("ee")(t, 1);
      }
    })]
  }), _get__("Re")(t, {
    scope: {
      sourceState: i,
      clockState: c,
      hasSource: a,
      fn: n
    },
    child: [o],
    node: [_get__("L").update({
      store: c
    }), _get__("L").filter({
      fn: function fn(e, _ref28) {
        var t = _ref28.hasSource;
        return _get__("$")(t);
      }
    }), !r && _get__("L").barrier({
      barrierID: _get__("te")(),
      priority: 'sampler'
    }), _get__("L").compute({
      fn: n ? function (e, _ref29) {
        var t = _ref29.sourceState,
            n = _ref29.clockState,
            r = _ref29.fn;
        return r(_get__("$")(t), _get__("$")(n));
      } : function (e, _ref30) {
        var t = _ref30.sourceState;
        return _get__("$")(t);
      }
    })].filter(Boolean)
  }), o;
},
    Qe = function Qe(e) {
  return _get__("je")(e) ? e : _get__("w")(e);
},
    Xe = _get__("L").run({
  fn: function fn(_ref31) {
    var e = _ref31.handler,
        t = _ref31.toHandler,
        n = _ref31.result;
    return e(t), n;
  }
});

var Ye = function Ye() {
  _classCallCheck(this, Ye);

  this.events = new Set(), this.effects = new Set(), this.storages = new Set(), this.domains = new Set();
};

var Ze = function Ze(e) {
  return {
    event: _get__("s")({
      name: e.fullName + " event hook",
      parent: e
    }),
    effect: _get__("s")({
      name: e.fullName + " effect hook",
      parent: e
    }),
    store: _get__("s")({
      name: e.fullName + " store hook",
      parent: e
    }),
    domain: _get__("s")({
      parent: e
    })
  };
},
    $e = function $e(e) {
  return {
    event: e.event.prepend(function (e) {
      return e;
    }),
    effect: e.effect.prepend(function (e) {
      return e;
    }),
    store: e.store.prepend(function (e) {
      return e;
    }),
    domain: e.domain.prepend(function (e) {
      return e;
    })
  };
},
    et = _get__("U")();

export { K as Kind, ke as blocks, Q as clearNode, O as combine, x as createApi, R as createDomain, M as createEffect, l as createEvent, e as createNode, N as createStore, O as createStoreObject, k as extract, Te as forward, f as fromObservable, z as invariant, De as is, Oe as isDomain, Ce as isEffect, qe as isEvent, Ie as isStore, je as isUnit, ge as launch, q as restore, E as restoreEffect, I as restoreEvent, j as restoreObject, D as sample, S as setStoreName, L as step, B as version, xe as warning, C as withProps };

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "X":
      return X;

    case "Fe":
      return Fe;

    case "Ie":
      return Ie;

    case "qe":
      return qe;

    case "Ce":
      return Ce;

    case "t":
      return t;

    case "r":
      return r;

    case "He":
      return He;

    case "Me":
      return Me;

    case "Be":
      return Be;

    case "o":
      return o;

    case "e":
      return e;

    case "L":
      return L;

    case "ge":
      return ge;

    case "P":
      return P;

    case "Re":
      return Re;

    case "we":
      return we;

    case "s":
      return s;

    case "a":
      return a;

    case "xe":
      return xe;

    case "c":
      return c;

    case "u":
      return u;

    case "z":
      return z;

    case "T":
      return T;

    case "l":
      return l;

    case "Q":
      return Q;

    case "$":
      return $;

    case "ee":
      return ee;

    case "m":
      return m;

    case "v":
      return v;

    case "d":
      return d;

    case "p":
      return p;

    case "Z":
      return Z;

    case "A":
      return A;

    case "h":
      return h;

    case "g":
      return g;

    case "b":
      return b;

    case "Se":
      return Se;

    case "y":
      return y;

    case "Te":
      return Te;

    case "We":
      return We;

    case "w":
      return w;

    case "I":
      return I;

    case "E":
      return E;

    case "j":
      return j;

    case "Ke":
      return Ke;

    case "Qe":
      return Qe;

    case "Je":
      return Je;

    case "_e":
      return _e;

    case "Le":
      return Le;

    case "Xe":
      return Xe;

    case "V":
      return V;

    case "ve":
      return ve;

    case "F":
      return F;

    case "N":
      return N;

    case "H":
      return H;

    case "et":
      return et;

    case "Ye":
      return Ye;

    case "$e":
      return $e;

    case "Ze":
      return Ze;

    case "W":
      return W;

    case "G":
      return G;

    case "U":
      return U;

    case "_":
      return _;

    case "J":
      return J;

    case "Y":
      return Y;

    case "ie":
      return ie;

    case "ce":
      return ce;

    case "oe":
      return oe;

    case "ne":
      return ne;

    case "le":
      return le;

    case "se":
      return se;

    case "fe":
      return fe;

    case "de":
      return de;

    case "ue":
      return ue;

    case "ye":
      return ye;

    case "re":
      return re;

    case "me":
      return me;

    case "ae":
      return ae;

    case "pe":
      return pe;

    case "he":
      return he;

    case "be":
      return be;

    case "Ne":
      return Ne;

    case "je":
      return je;

    case "Ee":
      return Ee;

    case "Oe":
      return Oe;

    case "i":
      return i;

    case "Ge":
      return Ge;

    case "ze":
      return ze;

    case "te":
      return te;

    case "n":
      return n;

    case "Ue":
      return Ue;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case "le":
      return le = _value;

    case "ue":
      return ue = _value;

    case "me":
      return me = _value;

    case "ze":
      return ze = _value;

    case "Ge":
      return Ge = _value;

    case "d":
      return d = _value;

    case "p":
      return p = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

export { _get__ as __get__, _get__ as __GetDependency__, _set__ as __Rewire__, _set__ as __set__, _reset__ as __ResetDependency__, _RewireAPI__ as __RewireAPI__ };
export default _RewireAPI__;